<template name="warehouse">
  <div class="ware-house" :class="{'show-warehouse': this.showCheckUser}">
    <div v-if="this.isWareHouseShow">{{$t('GoodsSheet')}}<i class="iconfont icon-close" @click="closeList"></i></div>
     <div v-if="!this.isWareHouseShow">{{$t('ExitPermit')}}<i class="iconfont icon-close" @click="closeList"></i></div>
    <div class="new-invisit-content">
      <div class="ware-view">
        <div class="row car-number" :class="{'form-error': errorMsgCheckCar}">
          <div class="col-4 l">{{$t('VisitCarNumber')}}</div>
          <div class="col-8 r">
            <div @click="selectCarNumberShowHide">
              <span></span><i class="iconfont icon-right"></i>
            </div>
          </div>
          <div class="col-12" v-if="carList.length > 0">
            <div class="car-number-list" v-for="(option, index) in carNumbersInfor" v-show="selectCarNumberShow" :key="index">
              <label><input v-model="postOptions" type="checkbox" :value="option">{{carList[index].displayContent}}
              </label>
            </div>
          </div>
          <div class="col-12" v-else>
            <div class="car-number-list" v-for="(option, index) in postOptionsInfor" v-show="selectCarNumberShow" :key="index">
              <label><input v-model="postOptions" type="checkbox" :value="option">{{postOptionsSelect[index].displayContent}}
              </label>
            </div>
          </div>
        </div>
        <label v-show="errorMsgCheckCar" class="error-msg">{{$t('ChoseVisitCarNumber')}}</label>
        <div class="row goods-code" :class="{'form-error': errorMsgoodsSerialNumber}">
          <div class="col-5">{{$t('GoodsNo')}} <span>{{$t('optional')}}</span></div>
          <div class="col-7"> <input type="text" v-model="goodsSerialNumber" :placeholder="$t('PleaseInputGoodsNO')"></div>
        </div>
        <label v-show="errorMsgoodsSerialNumber" class="error-msg">{{$t('inputGoodsN')}}</label>
        <div class="row dangerous">
          <div class="col-4">
            {{$t('Dangerous')}}
          </div>
          <div class="col-8">
            <div class="row">
              <div class="col-6" v-for="(item, index) in checkDangerousList">
                <label><input class="check-dangerous" v-model="checkDangerous"
                  type="radio" :value="item.value" name="dangerous">{{item.text}}</label>
              </div>
            </div>
          </div>
        </div>
        <div class="row shipment-number">
          <div class="col-5">{{$t('ShippingNumber')}}: <span>{{$t('optional')}}</span></div>
          <div class="col-7"> <input type="text" v-model="shipmentNumber" :placeholder="$t('WriteShippingNumber')"></div>
        </div>
        <div class="seal-number">
          <div>{{$t('SealNumber')}}: <span>{{$t('optional')}}</span></div>
          <div>
            <textarea v-model="sealNumber" :placeholder="$t('FillSealNumber')"></textarea>
          </div>
        </div>
        <div class="check-listing">
          <div>{{$t('DetailedDescription')}}</div>
          <div>
            <textarea v-model="checkListDetail" :placeholder="$t('fillDetailsHere')"></textarea>
          </div>
        </div>
        <label v-show="errorMsgCheckDetail" class="error-msg">{{$t('inputDetailedDescription')}}</label>
        <div class="uploadImg">
          <div>{{$t('uploadImage')}} <span class="optional">{{$t('optional')}}</span></div>
          <div>
            <div class="upload_warp_img row">
              <div class="upload_warp_img_div" v-for="(item,index) of goodsImagesList" v-show="goodsImagesList.length!=0">
                <div class="upload_warp_img_div_top">
                  <img src="../assets/images/delete@2x.png" class="upload_warp_img_div_del" @click="fileDel(index)">
                  <img class="newImg" :src="item">
                </div>
                
              </div>
              <div class="upload_warp_left" :class="{'upload-img': goodsImagesList.length}" @click="fileClick">
                <img src="../assets/images/upload@2x.png">
                <input @change="fileChange($event)" type="file" id="upload_file" multiple style="display: none"/>
              </div>
            </div>
          </div>
        </div>
        <label v-show="errorMsgUploadImg" class="error-msg">{{$t('uploadImage')}}</label>
        <div class="addCheck">
          <div class="people-list">
            <div>
              <div class="row" v-for="(user, idx) in approvedList" :key="idx">
                <div class="col-10">
                  <img class="head-portrait" :id="user.userId" :src="user.avatar">
                  <span>{{ user.userName }}({{ user.deptName }})</span>
                </div>
                <div class="col-2">
                  <img class="delete-people" src="../assets/images/2-copy-12@2x.png"
                  @click="deleteKO(user.userId)">
                </div>
              </div>
            </div>
          </div>
          <div class="selectCheckperson" @click="selectCheckUser" v-if="this.checkUserListLength !=0 && !isSecurity">
            <i class="iconfont icon-add"></i><span>{{$t('SelectApprover')}}</span>
          </div>
        </div>
        <label v-show="errorMsgCheckUser" class="error-msg">{{$t('PleaseApprover')}}</label>
        
        <div class="commitBtn" @click="confirmCommit">
          <span>{{$t('submit')}}</span>
        </div>
      </div>
    </div>
    <div v-show="showCheckUser" v-if="!isSecurity">
      <checkUser   @closeCheckUser="closeCheckUser" :invitationId='this.invitationId' @CheckStatus="getCheckList"></checkUser>
    </div>
    <div>
      <div class="commit-modal" v-show="isCommit">
        <div class="confirm-wrapper">
          <div class="confirm-header">
           {{$t('confirmToSubmit')}}
          </div>
          <div class="confirm-btn row">
            <div class="col-6" @click="isCommit = false">{{$t('Cancel')}}</div>
            <div class="col-6 confrim" @click="commitData">{{$t('confirm')}}</div>
          </div>
        </div>
      </div>
    </div>
    <transition>
      <div class="ko-list-confirm" v-show="isCheckConfirm">
        <div class="confirm-wrapper">
          <div class="confirm-header">
           {{addSucess}}
          </div>
          <div class="confirm-btn" @click="closeCheckConfirmModal">
            {{$t('confirm')}}
          </div>
        </div>
      </div>
    </transition>
    <loading :active.sync="isLoading" :color="'#e42029'"></loading>
  </div>
</template>

<script type="text/javascript">
  import checkUser from '@/components/checkUser.vue';
  import { uploadPictureByBase64, uploadPictureByBase64Security, insertOrUpdateDeliveryTrackingGoodsList, securityPicture, securityInsertOrUpdateDeliveryTrackingGoodsList} from '@/utils/api';
  import { checkNested, correctImgOrientation } from '@/utils/utils';
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  export default {
    name:'warehouse',
    props: {
      invitationId: String,
      carNumberList: String
    },
    components: {
      checkUser,
      Loading,
    },
    data() {
      return {
        showCheckUser: false,
        imgList: [],
        size: 0,
        errorMsgoodsSerialNumber: false,
        errorMsgCheckDetail: false,
        errorMsgCheckUser: false,
        errorMsgUploadImg: false,
        checkDangerous: false,
        goodsSerialNumber: '',
        checkListDetail: '',
        approvedList: [],
        checkDangerousList: [
          {
            value: false,
            'text': this.$t('no')
          },
          {
            value: true,
            'text': this.$t('yes')
          }
        ],
        isCommit: false,
        isCheckConfirm: false,
        addSucess: '',
        isSuccess: false,
        goodsImagesList: [],
        getGoods: {},
        goodsDtail: {},
        goodsId: 0,
        isLoading: false,
        checkUserList: [],
        isSecurityStatus: false,
        isSecurity: true,
        checkUserListLength: 0,
        isWareHouseShow: false,
        carNumbersInfor:[],
        carList: [],
        selectCarNumberShow: false,
        sealNumber: '',
        options: null,  
        postOptions: [],
        errorMsgCheckCar: false,
        postOptionsSelect: [],
        postOptionsInfor: [],
        shipmentNumber: ""
      }
    },
    created() {
    },
    watch: {
      carNumberList(value) {
        const carNumberLists = value;
        this.carList = JSON.parse(carNumberLists);
        this.carNumbersInfor = [];
        this.carList.forEach(item =>{
          this.carNumbersInfor.push(JSON.stringify(item));
        });
      },
      postOptions(value) {
        if(value) {
          this.errorMsgCheckCar = false;
        }
      }
    },
    methods: {
     selectCarNumberShowHide() {
       this.selectCarNumberShow = !this.selectCarNumberShow;
     },
     closeList() {
       this.$emit('closeNewWarehouse', false);
     },
      selectCheckUser() {
        this.showCheckUser = true;
      },
      closeCheckUser(status) {
        this.showCheckUser = status;
      },
      fileClick() {
          document.getElementById('upload_file').click()
      },
      fileChange(el) {
          var that = this;
          if (!el.target.files[0].size) return;
          this.fileList(el.target);
          // console.log('上传图片');
          const filesList = el.target.files;
          const uploadImg = that.isSecurity ? uploadPictureByBase64Security : uploadPictureByBase64;
          const imgHandler = (dataUrl) => {
            uploadImg({ isDocPhoto: 0, filePath: dataUrl }).then((res) => {
              if (checkNested(res, 'data', 'content', 'model')) {
                that.goodsImagesList.push(res.data.content.model);
                that.isLoading = false;
              }
            });
          }
          that.isLoading = true;
          for (let i = 0; i < filesList.length; i++) {
            var that = this;
            (function (a) {
              correctImgOrientation(el.target.files[a], (base64Url) => { imgHandler(base64Url); });
            }(i));
          }
          //console.log(this.goodsImagesList);
          el.target.value = '';
      },
      fileList(fileList) {
          let files = fileList.files;
          for (let i = 0; i < files.length; i++) {
              //判断是否为文件夹
              if (files[i].type != '') {
                  this.fileAdd(files[i]);
              } else {
                  //文件夹处理
                  this.folders(fileList.items[i]);
              }
          }
      },
      //文件夹处理
      folders(files) {
          let _this = this;
          //判断是否为原生file
          if (files.kind) {
              files = files.webkitGetAsEntry();
          }
          files.createReader().readEntries(function (file) {
              for (let i = 0; i < file.length; i++) {
                  if (file[i].isFile) {
                      _this.foldersAdd(file[i]);
                  } else {
                      _this.folders(file[i]);
                  }
              }
          })
      },
      foldersAdd(entry) {
          let _this = this;
          entry.file(function (file) {
              _this.fileAdd(file)
          })
      },
      fileAdd(file) {
          //总大小
          this.size = this.size + file.size;
          //判断是否为图片文件
          if (file.type.indexOf('image') == -1) {
              file.src = 'wenjian.png';
              this.imgList.push({
                  file
              });
          } else {
              let reader = new FileReader();
              reader.vue = this;
              reader.readAsDataURL(file);
              reader.onload = function () {
                  file.src = this.result;
                  this.vue.imgList.push({
                      file
                  });
              }
          }
          
      },
      fileDel(index) {
         // this.size = this.size - this.imgList[index].file.size;//总大小
          this.goodsImagesList.splice(index, 1);
      },
      getCheckList(data) {
        data.forEach((x) => {
          // console.log(this.approvedList);
          if (this.approvedList.findIndex(y => y.userId === x.userId) === -1) {
            this.approvedList = [...this.approvedList, x];
          }
        });
      },
      deleteKO(id) {
        this.approvedList = this.approvedList.filter(x => x.userId !== id);
        // console.log(this.approvedList);
      },
      confirmCommit() {
        if (!this.isSecurity) {
         // this.errorMsgoodsSerialNumber = this.goodsSerialNumber == '';

          this.errorMsgCheckDetail = this.checkListDetail == '';
          this.errorMsgCheckCar = this.postOptions == '';
          
          if(this.errorMsgCheckCar) {
            this.selectCarNumberShow = true;
          }
         // this.errorMsgUploadImg = this.goodsImagesList.length == 0;
          if (this.checkUserListLength != 0) {
            this.errorMsgCheckUser = this.approvedList.length == 0;
          }

          if(!this.errorMsgCheckDetail && !this.errorMsgCheckUser && !this.errorMsgCheckCar) {
            this.isCommit = true;
          }
        } else {
          this.errorMsgCheckDetail = this.checkListDetail == '';
          this.errorMsgCheckCar = this.postOptions == '';

          if(this.errorMsgCheckCar) {
            this.selectCarNumberShow = true;
          }

         // this.errorMsgUploadImg = this.goodsImagesList.length == 0;
          if(!this.errorMsgCheckDetail && !this.errorMsgCheckCar) {
            this.isCommit = true;
          }
        }  
      },
      commitData() {
        var visitApprovedList = [];
        // console.log('图片');
        // console.log(this.goodsImagesList);
        this.approvedList.forEach((array, index) => {
          const rObj = {};
          rObj.id = 0,
          rObj.userId = array.userId;
          rObj.userName = array.userName;
          rObj.checkStatus = 0;
          visitApprovedList.push(rObj);
        });
        var dataObj = {};
        const agreeOutListData = [];
        this.postOptions.forEach(item => {
          agreeOutListData.push(JSON.parse(item));
        });
        
        if (this.goodsId == 0) {
           dataObj = {
            "id": 0,
            "ticketId": this.invitationId,
            "goodsSerialNumber": this.goodsSerialNumber,
            "isDangerous": this.checkDangerous,
            "goodsDetail": this.checkListDetail,
            "goodsImages": this.goodsImagesList,
            "checkUsers": visitApprovedList,
            "sealNumber": this.sealNumber,
            "agreeOutList": agreeOutListData,
            "shipmentNumber": this.shipmentNumber
          }
        } else {
          dataObj = {
            "id": this.goodsId,
            "ticketId": this.invitationId,
            "goodsSerialNumber": this.goodsSerialNumber,
            "isDangerous": this.checkDangerous,
            "goodsDetail": this.checkListDetail,
            "goodsImages": this.goodsImagesList,
            "checkUsers": visitApprovedList,
            "sealNumber": this.sealNumber,
            "agreeOutList": agreeOutListData,
            "shipmentNumber": this.shipmentNumber
          }
        }
        console.log('提交的车辆信息');
        console.log(dataObj);
        this.isLoading = true;
        
        // console.log('isSercurity=='+ this.isSecurity);
        this.isCommit = false;
        if (this.isSecurity) {
          securityInsertOrUpdateDeliveryTrackingGoodsList(dataObj).then((res) => {
              this.isLoading = false;
              if (checkNested(res, 'data', 'content', 'model')) {
                if (res.data.content.status === 1) {
                  this.isCheckConfirm = true;
                  this.isSuccess = true;
                  this.addSucess = res.data.content.model;
                } else {
                  this.isSuccess = false;
                  this.isCheckConfirm = true;
                  this.addSucess = res.data.content.message;
                }
              }
          })
        } else {
          insertOrUpdateDeliveryTrackingGoodsList(dataObj).then((res) => {
              this.isLoading = false;
              if (checkNested(res, 'data', 'content', 'model')) {
                if (res.data.content.status === 1) {
                  this.isCheckConfirm = true;
                  this.isSuccess = true;
                  this.addSucess = res.data.content.message;
                } else {
                  this.isSuccess = false;
                  this.isCheckConfirm = true;
                  this.addSucess = res.data.content.message;
                }
              }
          })
        }
        
      },
      closeCheckConfirmModal() {
        if (this.isSuccess) {
          window.location.reload();
        } else {
          this.isCommit = false;
          this.isCheckConfirm = false;
        }
      },
      loadDialogData(getData, isSecurityStatus, checkUserListLength,isWareHouse) {
        if (getData) {
          this.goodsDtail = getData;
          this.goodsSerialNumber = this.goodsDtail.goodsSerialNumber;
          this.shipmentNumber = this.goodsDtail.shipmentNumber;
          this.checkDangerous = this.goodsDtail.isDangerous;
          this.checkListDetail = this.goodsDtail.goodsDetail;
          this.goodsImagesList = this.goodsDtail.goodsImages;
          this.approvedList = this.goodsDtail.checkUsers;
          this.goodsId = this.goodsDtail.id;
          this.sealNumber = this.goodsDtail.sealNumber;
          this.shipmentNumber = this.goodsDtail.shipmentNumber;

          const postOptions = [];

          if (this.goodsDtail.numberPlateList && this.goodsDtail.numberPlateList.length >0) {
            this.goodsDtail.numberPlateList.forEach(item =>{
              postOptions.push(JSON.stringify(item));
            });
          }

          this.postOptions = postOptions;
          console.log("检查入园人员");
          console.log(getData.numberPlateList);
          console.log("车辆信息");
          console.log(this.carList);
          if (this.carList == "") {
            this.postOptionsInfor = postOptions;
            this.postOptionsSelect = [];
            this.postOptions.forEach(item => {
              this.postOptionsSelect.push(JSON.parse(item));
            });
          }
        } else {
          this.goodsSerialNumber = '';
          this.checkDangerous = false;
          this.checkListDetail = '';
          this.goodsImagesList = [];
          this.approvedList = [];
          this.options = [];
          this.sealNumber = '';
          this.shipmentNumber = '';
        }
        this.isWareHouseShow = isWareHouse;
        this.isSecurity = isSecurityStatus;
        // console.log('isSecurity=='+ this.isSecurity);
        this.checkUserListLength = checkUserListLength;
        // console.log(this.checkUserListLength);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ware-house {
    background-color: #fff;
    border-radius: 10px 10px 0 0;
    width: 100%;
    bottom: 0;
    position: absolute;
    overflow: hidden;
    &.show-warehouse {
      border-radius: 0;
      bottom: inherit;
      height: 100vh;
    }
    & > div:first-child {
      padding: 20px 5% 5px;
      font-size: 18px;
      color: #4a4a4a;
      line-height: 1;
      font-weight: bold;
      i {
        display: inline-block;
        float: right;
        font-size: 22px;
        font-weight: normal;
      }
    }
    .new-invisit-content {
      width: 100%;
      height: calc(100vh - 139px);
      overflow-x: hidden;
      overflow-y: auto;
      .ware-view {
        padding: 20px 5%;
        .goods-code,
        .shipment-number,
        .seal-number {
          span {
            color: #929292;
            font-size: 12px;
          }
        }
        .error-msg {
          color: #e42029;
          font-size: 11px;
          text-align: right;
          width: 100%;
        }
        .goods-code,
        .shipment-number {
          padding: 8px 0;
          border-bottom: 1px solid rgba(57, 74, 84, 0.08);
          margin: 0;
          &.form-error {
            border-bottom: 1px solid red;
          }
          & > div:first-child {
            padding: 0;
            font-size: 13px;
            color: #4a4a4a;
          }
          & > div:last-child {
            padding: 0;
            text-align: right;
            font-size: 13px;
            color: #929292;
            input {
              font-size: 13px;
              text-align: right;
              color: #4a4a4a;
              &::-webkit-input-placeholder {
                color: #929292;
              }
            }
          }
        }
        .dangerous {
          padding: 8px 0;
          border-bottom: 1px solid rgba(57, 74, 84, 0.08);
          margin: 0;
          & > div:first-child {
            padding: 0;
            color: #4a4a4a;
            font-size: 13px;
            line-height: 31px;
          }
          & > div:last-child {
            text-align: right;
            line-height: 31px;
          }
          label {
            color: #4a4a4a;
            font-size: 13px;
            margin-bottom: 0;
          }
          input.check-dangerous[type='radio'] {
            width: 23px;
            height: 23px;
            appearance: none;
            background-color: #fff;
            outline: none;
            vertical-align: text-bottom;
            margin-bottom: -4px;
            margin-right: 7px;
            background: url(../assets/images/copy-21.png) no-repeat center;
          }
          input.check-dangerous[type='radio']:checked {
            background: url(../assets/images/11-copy.png) no-repeat center;
          }
        }
        .check-listing, 
        .seal-number,
        .car-number {
          margin: 0;
          padding: 12px 0;
          & > div:first-child {
            font-size: 13px;
            color: #4a4a4a;
            padding-bottom: 10px;
          }
          & > div:last-child {
            textarea {
              width: 100%;
              background-color: #f0f0f0;
              font-size: 13px;
              color: #4a4a4a;
              border: 0;
              padding: 5px 10px;
              height: 90px;
              &::-webkit-input-placeholder {
                color: #929292;
              }
            }
          }
        }
        .car-number {
          padding:8px 0;
          border-bottom: 1px solid rgba(57, 74, 84, 0.08);
          &.form-error {
            border-color: #e42029;
          }
          .l, 
          .r {
            padding: 0 !important;
          }
          .r {
            text-align: right;
          }
          .car-number-list {
            display: inline-block;
            margin-right: 10px;
            vertical-align: top;
            overflow-y: scroll;
            max-height: 80px;
          }
          label {
            line-height:16px;
            font-size: 14px;
            color: #4a4a4a;
            margin-right: 10px;
          }
          .no-car {
            color: #929292;
            font-size: 12px;
            margin-bottom: 0;
          }
          input[type='checkbox'] {
            width: 16px;
            height: 16px;
            appearance: none;
            background-color: #fff;
            outline: none;
            vertical-align: text-bottom;
            margin-bottom: -4px;
            margin-right: 4px;
            background: url(../assets/images/copy-21.png) no-repeat center;
            background-size: 100%;
            vertical-align: top;
            display:inline-block;
          }
          input[type='checkbox']:checked {
            background: url(../assets/images/11-copy.png) no-repeat center;
            background-size: 100%;
          }
        }
        .seal-number {
          padding-bottom: 0;
          & > div:first-child {
            font-size: 13px;
            color: #4a4a4a;
            padding-bottom: 8px;
          }
          textarea {
            height: 90px;
            line-height: 16px;
          }
        }
        .selectCheckperson {
          margin: 0;
          border-radius: 4px;
          background-color: #fff;
          padding: 16px 12px;
          i {
            font-size: 14px;
            color: #e42029;
            margin-right: 5px;
          }
          span {
            font-size: 14px;
            color: #4a4a4a;
          }
        }
        .uploadImg {
          margin-bottom: 20px;
          & > div:first-child {
            font-size: 14px;
            color: #4a4a4a;
            .optional {
              color: #929292;
              font-size: 12px;
            }
          }
        }
      }
    }
  }
  .wareHouse-view .new-invisit-content {
    width: 100%;
    height: auto;
  }
  .upload_warp_img {
    padding-top: 14px;
    overflow: hidden;
    margin: 0;
    .upload_warp_img_div {
      position: relative;
      height: 100px;
      width: 100px;
      margin: 0px 15px 15px 0px;
      float: left;
      line-height: 100px;
      display: table-cell;
      text-align: center;
      cursor: pointer;
      img {
        max-width: 100%;
        max-height: 100%;
        width: 100%;
        height: 100px;
        vertical-align: middle;
      }
      .upload_warp_img_div_top {
        position: absolute;
        top: 0px;
        right: 0px;
        width: 100%;
        line-height: 30px;
        text-align: right;
        color: #fff;
        font-size: 12px;
        //text-indent: 4px;
        margin: 0;
        vertical-align: middle;
        & > div:first-child {
          float: right;
        }
        img.upload_warp_img_div_del {
          width: 20px;
          height: 20px;
          position: absolute;
          right: -6px;
          top: -8px
        }
        img.newImg {
          // width: 100px;
          // height: 100px;
        }
      }
    }
    .upload_warp_left {
      width: 100px;
      height: 100px;
      margin-left: 0;
      &.upload-img {
        margin-left: 0px;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .commitBtn {
    margin-top: 20px;
    width: 100%;
    height: 46px;
    line-height: 46px;
    border-radius: 5px;
    background-image: linear-gradient(81deg, #f36443, #e42029);
    text-align: center;
    span {
      font-size: 15px;
      font-weight: 600;
      color: #fff;
    }
  }
  .addCheck {
   width: 100%;
   margin: auto;
   width: 100%;
   margin: 0 auto;
   padding: 0;
   background-color: #fff;
   border-radius: 4px;
   box-shadow: 0 0 25px rgba(100, 100, 100, 0.15);
  }
  .people-list {
    border-bottom: 1px solid #f0f1f2;
    & > div {
      padding: 0 12px;
      .row {
        margin: 0;
        padding-top: 5px;
        padding-bottom: 5px;
        align-items: center;
        border-bottom: 1px solid #f0f1f2;
        div {
          padding: 0;
          font-size: 13px;
          color: #4a4a4a;
          img.head-portrait {
            width: 40px;
            height: 40px;
            margin-right: 10px;
            border-radius: 50%;
          }
          .delete-people {
            width: 20px;
            height: 20px;
          }
        }
        & > div:nth-of-type(2) {
          text-align: right;
          padding-right: 10px;
        }
      }
    }
  }
  .commit-modal {
    height: 140%;
    background: rgba(0,0,0,.4);
    z-index: 100;
    //position: absolute;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    left: 0;
    top: 0;
    position: fixed;
    .confirm-wrapper {
      background: #fcfcfc;
      width: 72%;
      border-radius: 12px;
      font-size: 17px;
      text-align: center;
      .confirm-header {
        padding: 34.5px 0 20px;
        border-bottom: 1px solid #f0f1f2;
      }
      .confirm-btn {
        height: 40px;
        line-height: 40px;
        color: #e42029;
        & > div:first-child {
          border-right: 1px solid #f0f1f2;
          font-size: 17px;
          color: #4a4a4a;
        }
      }
    }
  }
  .ko-list-confirm {
    height: 140%;
    background: rgba(0,0,0,.4);
    z-index: 100;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .confirm-wrapper {
      background: #fcfcfc;
      width: 72%;
      border-radius: 12px;
      font-size: 17px;
      text-align: center;
      .confirm-header {
        padding: 34.5px 0 20px;
        border-bottom: 1px solid #f0f1f2;
      }
      .confirm-btn {
        padding: 12px 0;
        color: #e42029;
      }
    }
  }
</style>